import React from 'react';

import fallbackDictionary from './fallbackDictionary';
import { PinCodePattern, Piwik, SiteCoreDictionary } from './types';

import './PinCode.scss';

interface PinCodeProps {
    /** Pin code as a 4 digit string */
    pin: PinCodePattern;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

type PinProps = {
    pin: PinCodePattern;
};

const MobileView = ({ pin }: PinProps) => <div className="pin-code-box">{pin}</div>;

const DesktopView = ({ pin }: PinProps) => {
    const digits = pin.split('');

    return (
        <div className="digit-boxes-container">
            {digits.map((digit, index) => (
                <div className="digit-box" key={`pin-digit${index + 1}`}>
                    {digit}
                </div>
            ))}
        </div>
    );
};

const PinDisplay = ({ pin }: PinProps) => (
    <div>
        <div className="pin-code-container mobile">
            <MobileView pin={pin} />
        </div>
        <div className="pin-code-container desktop">
            <DesktopView pin={pin} />
        </div>
    </div>
);

const PinCode = ({ pin, sitecoreDictionary, piwik }: PinCodeProps) => {
    const dictionary: SiteCoreDictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <div aria-live="polite" className="pin-code-container">
            <p className="pin-code-label">{dictionary.yourPinCodeIs}</p>
            <div
                aria-labelledby="pin-code-label"
                className="pin-code"
                data-track-id={piwik?.pinCode?.pinCodeDisplay?.dataTrackId}
                data-track-linkname={piwik?.pinCode?.pinCodeDisplay?.dataTrackLinkname}
                id={piwik?.pinCode?.pinCodeDisplay?.dataTrackId}
            >
                <PinDisplay pin={pin} />
            </div>
        </div>
    );
};

export default PinCode;
